import * as React from "react";
import { Grid, Link } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import GeneralModal from "./GeneralModal";
import { ImagesContext } from "../Context";
import { cgmInfoPdfSrc } from "../../utils/cgmInfoPdfSrc";

interface Props {
  modalOpen: boolean;
  setModalOpen: any;
}

const CgmInfo: React.FC<Props> = (props: Props) => {
  const [pageNum, setPageNum] = React.useState<number>(1);
  const images = React.useContext(ImagesContext);

  const page1Src = cgmInfoPdfSrc(images.dexcom_info_page_1_src);
  const page2Src = cgmInfoPdfSrc(images.dexcom_info_page_2_src);

  return (
    <GeneralModal
      open={props.modalOpen}
      title={"Glucose Monitoring Resource"}
      successCallback={undefined}
      closeCallback={() => props.setModalOpen(false)}
      containerClassName="add-patient-modal"
      confirmButtonText="Confirm"
      width="700px"
      showContinueIcon={false}
      showCancelButton={false}
    >
      <Grid container justifyContent="center" className="fum-form-container">
        {pageNum == 1 ? (
          <iframe src={page1Src} width="100%" height="600px"></iframe>
        ) : (
          <iframe src={page2Src} width="100%" height="600px"></iframe>
        )}
        <Grid justifyContent="center">
          <p className="pagerLinks">
            <Link
              onClick={() => {
                setPageNum(1);
              }}
              className="linkDark"
            >
              <ArrowBackIosIcon />
            </Link>
            <Link
              key={1}
              onClick={() => {
                setPageNum(1);
              }}
              className={pageNum === 1 ? "linkDark" : "linkLight"}
            >
              1
            </Link>
            <Link
              key={2}
              onClick={() => {
                setPageNum(2);
              }}
              className={pageNum === 2 ? "linkDark" : "linkLight"}
            >
              2
            </Link>
            <Link
              onClick={() => {
                setPageNum(2);
              }}
              className="linkDark"
            >
              <ArrowForwardIosIcon />
            </Link>
          </p>
        </Grid>
      </Grid>
    </GeneralModal>
  );
};

export default CgmInfo;
